<div *ngIf="indicator; else missingdata" class="indicator-container">
    <div class="indicator-value">{{ indicator }}</div>
    <div class="indicator-delta" *ngIf="delta">
        <div clas="indicator-delta-rating" [ngClass]="{'text-success': deltaRating === 'positive', 'text-warn': deltaRating === 'negative', 'text-muted': deltaRating }">
            <span class="di di-peak"></span>
        </div>
        <div class="indicator-delta-value">{{ delta }}</div>
    </div>
    <div class="indicator-delta" *ngIf="trend">
        <span class="di di-3x" [ngClass]="trendRating"></span>
    </div>
</div>
<ng-template #missingdata>
    <div class="indicator-value">-</div>
</ng-template>